import React from "react";
import {Breadcrumb, Layout, Menu, Typography} from "antd";
import { UserOutlined, LaptopOutlined, NotificationOutlined } from '@ant-design/icons';
import {ClassTable} from "../ClassAndStudentParts/ClassTable";
import {getFrontEndAddress} from "../../Tool/UtileFun"
import {TaskTable} from "./TaskTable";
import cookie from "react-cookies";

export function TaskLayout(){

    const classPage = () =>{
        window.location.href="http://"+getFrontEndAddress()+"/admin/class"
    }
    const studentPage = () =>{
        window.location.href="http://"+getFrontEndAddress()+"/admin/student"
    }
    const taskPage = () =>{
        window.location.href="http://"+getFrontEndAddress()+"/admin/task"
    }
    const outLogin = () =>{
        const username = "username"
        const classId = "classID"
        const role = "role"
        const userId = "userId"
        const roleTest = "admin"
        cookie.remove(userId)
        cookie.remove(username)
        cookie.remove(role)
        cookie.remove(classId)
        cookie.remove(roleTest)
        window.location.href="http://"+getFrontEndAddress()+"/admin/login"
    }
    const { SubMenu } = Menu;
    const { Header, Content, Sider } = Layout;
    const { Text, Link } = Typography;
    const layout = (
        <Layout>
            <Header className="header">
                <div className="logo" />
                <Menu theme="dark" mode="horizontal" defaultSelectedKeys={['1']}>
                    <Menu.Item key="1">后台管理</Menu.Item>
                    {/*<Menu.Item key="2">nav 2</Menu.Item>
                    <Menu.Item key="3">nav 3</Menu.Item>*/}
                </Menu>
            </Header>
            <Layout>
                <Sider width={200} className="site-layout-background">
                    <Menu
                        mode="inline"
                        defaultSelectedKeys={['3']}
                        defaultOpenKeys={['sub2']}
                        style={{ height: '100%', borderRight: 0 }}
                    >
                        <SubMenu key="sub1" icon={<UserOutlined />} title="基础管理">
                            <Menu.Item key="1" onClick={classPage}>班级管理</Menu.Item>
                            <Menu.Item key="2" onClick={studentPage}>学生管理</Menu.Item>
                        </SubMenu>
                        {/*<SubMenu key="sub2" icon={<UserOutlined />} title="作业管理">*/}
                        {/*    <Menu.Item key="3" onClick={taskPage}>作业批改</Menu.Item>*/}
                        {/*</SubMenu>*/}
                        {/*<SubMenu key="sub3" icon={<UserOutlined />} title="账号管理">*/}
                        {/*    <Menu.Item key="4" onClick={outLogin}><Text type="danger">退出</Text></Menu.Item>*/}
                        {/*</SubMenu>*/}
                    </Menu>
                </Sider>
                <Layout style={{ padding: '0 24px 24px' }}>
                    <Breadcrumb style={{ margin: '16px 0' }}>
                        {/*<Breadcrumb.Item>Home</Breadcrumb.Item>*/}
                        {/*<Breadcrumb.Item>List</Breadcrumb.Item>*/}
                        {/*<Breadcrumb.Item>App</Breadcrumb.Item>*/}
                    </Breadcrumb>
                    <Content
                        className="site-layout-background"
                        style={{
                            //overflow: 'initial',
                            minHeight: document.body.clientHeight
                        }}
                        // style={{
                        //     padding: 24,
                        //     margin: 0,
                        //     minHeight: 280,
                        //     height: 615,
                        // }}
                    >
                        <TaskTable></TaskTable>
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    )

    return(
        layout
    )
}
